import styled, { css } from 'styled-components';
import { TransparentButtonStylesType } from './TransparentButton.component';

const saveButtonCss = css`
  color: ${(props) => props.theme.colors['primary-60']};
  svg {
    fill: ${(props) => props.theme.colors['primary-60']};
  }
  &:hover {
    color: ${(props) => props.theme.colors['primary-40']};
    svg {
      fill: ${(props) => props.theme.colors['primary-40']};
    }
  }
`;

const redOnHover = css`
  &:hover {
    color: ${(props) => props.theme.colors['light-red']};
    svg {
      fill: ${(props) => props.theme.colors['light-red']};
    }
  }
`;

export const TransparentButton = styled.button<TransparentButtonStylesType>`
  font-size: 14px;
  line-height: 21px;
  display: flex;
  align-items: center;
  color: #6f7175;
  transition: all 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
  cursor: pointer;

  padding: 4px 8px;
  border-radius: 8px;

  svg {
    width: 14px;
    margin-right: 6px;
    fill: #6f7175;
  }

  &:hover {
    color: ${(props) => props.theme.colors['primary-60']};
    background-color: ${(props) => props.theme.colors['neutral-20']};
    svg {
      fill: ${(props) => props.theme.colors['primary-60']};
    }
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.6;
  }

  ${({ isRedButton }) => isRedButton && redOnHover};
  ${({ isBlueButton }) => isBlueButton && saveButtonCss};
`;
